import styled from 'styled-components';

export const Name = styled.span`
    @media screen and (max-width: 800px) {
        visibility: hidden;
    }
`